import React from 'react';
import { SelectAndOptionsStyle } from './style';

export default function SelectAndOptions({ title, id, optionsArray, widthPercentage }) {
  return (
    <SelectAndOptionsStyle widthPercentage={widthPercentage}>
      <label htmlFor={id}>{title}</label>
      <select name={id} id={id}>
        {optionsArray.length > 0 &&
          optionsArray.map((option, index) => {
            return (
              <option key={index + 1} value={option}>
                {option}
              </option>
            );
          })}
      </select>
    </SelectAndOptionsStyle>
  );
}
